<div class="area-row" [class.is-disabled]="disabled()">
  <div class="area-text">
    <p class="area-label">{{ meta().label }}</p>
    <p class="area-description">{{ meta().description }}</p>
    @if (grantNote(); as note) {
      <p class="area-grant-note">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>{{ note }}</span>
      </p>
    }
  </div>

  <!-- Two or three states, driven by `supportsRead` from the server's
       `read_only_areas`. Never hard-code which areas offer the middle
       state: requesting `read` on an area without a read-only form is a
       422, and promoting it to full access instead would silently grant
       more than the operator asked for. -->
  <div
    class="segmented"
    role="radiogroup"
    [attr.aria-label]="'member_access.area.state_label' | transloco: { area: meta().label }"
  >
    <button
      type="button"
      class="seg-btn is-off"
      role="radio"
      [class.is-active]="state() === 'off'"
      [attr.aria-checked]="state() === 'off'"
      [disabled]="disabled()"
      (click)="select('off')"
    >
      {{ 'member_access.area.off' | transloco }}
    </button>
    @if (supportsRead()) {
      <button
        type="button"
        class="seg-btn is-read"
        role="radio"
        [class.is-active]="state() === readMode"
        [attr.aria-checked]="state() === readMode"
        [disabled]="disabled()"
        (click)="select(readMode)"
      >
        {{ 'member_access.area.view_only' | transloco }}
      </button>
    }
    <!-- `supportsWrite` is the entitlement axis, not the shape axis: the
         button stays rendered (the state exists) but is unselectable when the
         org's plan caps this area at view-only. `title` rather than
         `matTooltip` — a disabled button has no pointer events, so the
         Material tooltip never fires. -->
    <button
      type="button"
      class="seg-btn is-read-write"
      role="radio"
      [class.is-active]="state() === readWriteMode"
      [attr.aria-checked]="state() === readWriteMode"
      [disabled]="disabled() || !supportsWrite()"
      [title]="supportsWrite() ? '' : ('member_access.area.full_not_entitled' | transloco)"
      (click)="select(readWriteMode)"
    >
      {{ 'member_access.area.full_access' | transloco }}
    </button>
  </div>
</div>
